import { shade } from 'polished'
import styled from 'styled-components'

interface IStatusCardLegacyListStyledProps {}

export const StatusCardLegacyListStyled = styled.div<IStatusCardLegacyListStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  border-top: 1px solid ${(props) => props.theme.colors.content.border};
  border-bottom: 1px solid ${(props) => props.theme.colors.content.border};
`
